/**
 * Dónde guarda la capa del satélite sus teselas (solo Pest, no viene de Tactic).
 * Módulo sin dependencias a propósito: lo leen `esriSatelliteLayer` (que trae
 * Leaflet) y lo rellena `teselasOffline` al arrancar, sin que importar uno
 * arrastre al otro (Leaflet no se puede cargar fuera del navegador).
 */
export interface AlmacenTeselas {
  leer(clave: string): Promise<Blob | null>;
  guardar(clave: string, blob: Blob): void;
}

let almacen: AlmacenTeselas | null = null;

export function usarAlmacenTeselas(a: AlmacenTeselas | null): void {
  almacen = a;
}

export function almacenTeselas(): AlmacenTeselas | null {
  return almacen;
}
